import { Scene as BScene } from '@babylonjs/core/scene';
import { ResourceContext } from '@seddi/core';
import { type Logo } from '@seddi/scene';
import { type IBabylonLogo } from './logoTypes';
import { type LogoLoader } from './logoLoader';

/**
 * Class for managing the loading and storage of logos.
 */
export class LogosContext extends ResourceContext<IBabylonLogo> {
  /** Logo loader. */
  private readonly logoLoader: LogoLoader;

  /**
   * Creates a new logo resources context.
   * @param logoLoader - Fx scene.
   */
  constructor(logoLoader: LogoLoader) {
    super();
    this.logoLoader = logoLoader;
  }

  /**
   * Loads the logo.
   * If the logo is already loaded, returns a resolved promise.
   * If the logo is currently being loaded, returns a promise that will be resolved when the logo finishes loading.
   * @param logo - Logo to load.
   */
  public async loadEx(logo: Logo): Promise<void> {
    const resourceId = logo.id;
    return super.load(
      resourceId,
      () => this.logoLoader.loadAsync(logo),
      (logo: IBabylonLogo) => this.logoLoader.unload(logo),
    );
  }
}
